module.exports = __webpack_public_path__ + "24a9b3bf9734d8f49945401ab79c90d0.svg";